








import { Component, Vue } from "vue-property-decorator";
import FormularioTalleres from "@/components/Formularios/FormularioTalleres.vue";

@Component({
  components: {
    FormularioTalleres
  },
  meta: {
    // sets document title
    title:
      "Formulario Inscripción a Talleres 2025 - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class TalleresView extends Vue {
  private mounted() {
    document.title =
      "Formulario Inscripción a Talleres 2025 - Ilustre Municipalidad de Punta Arenas";
  }
}
